import React, { useState, useEffect } from 'react'
import {
  IconButton,
  Icon,
  Panel,
  ControlLabel,
  FormGroup,
  Grid,
  Form,
  Row,
  Col,
  Message,
  Input,
  Modal,
  Table,
  Button,
  ButtonGroup,
} from 'rsuite'
import TooltipButton from '../../../components/buttons/TooltipButton'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import { requiredFiled, isValidators } from '../../../utils/ValidatorUtils'

export default function ProjectOrganizationForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onSubmit,
  onDelete,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const { isDeleteError, isError, loading } = props

  const [organization, setOrganization] = useState()
  const [responsibilityRole, setResponsibilityRole] = useState()
  const [editId, setEditId] = useState()
  const [isAdd, setIsAdd] = useState(false)
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isSaveError, setIsSaveError] = useState(false)
  const [isdelete, setIsdelete] = useState(false)
  const [deleteId, setDeleteId] = useState()

  const [schema, setSchema] = useState({})

  const selectedIdName = 'selectedId'

  useEffect(() => {
    // let schema = _schema
    console.log('ProjectOrganizationForm _schema', _schema)
    setSchema(_schema)
    setIsAdd(isError)
    setEditId('')
    setValue(selectedIdName, '')
  }, [_schema])

  useEffect(() => {
    setIsSaveError(isError)
    setIsAdd(isError)
  }, [isError])

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
  }, [isDeleteError])

  const onAdd = () => {
    setOrganization('')
    setResponsibilityRole('')

    setIsAdd(true)
    setIsDeleteFail(false)
    setIsSaveError(false)
    setEditId('')
    setValue(selectedIdName, '')
  }
  const handleEdit = (data) => {
    // let data = dataList[index]
    console.log('data', data, 'schema', schema)

    setOrganization(data.organization)
    setResponsibilityRole(data.responsibilityRole)

    setIsAdd(true)
    setIsDeleteFail(false)
    setIsSaveError(false)
    setEditId(data.projectCoId)
    setValue(selectedIdName, data.projectCoId)
    setValue(schema.organization.name, data.organization)
    setValue(schema.responsibilityRole.name, data.responsibilityRole)
  }

  const AddForm = () => {
    return (
      <Grid fluid>
        <Form fluid>
          <FormGroup>
            <Controller
              key={selectedIdName}
              name={selectedIdName}
              control={control}
              defaultValue={editId}
            />
            <Row>
              <Col xs={24} sm={12} md={8} lg={8}>
                <ErrorMessage error={errors[schema.organization.name]} />
                <ControlLabel>
                  {requiredFiled(schema.organization.validators, schema.organization.label)}
                </ControlLabel>
                <Input
                  name={schema.organization.name}
                  defaultValue={organization}
                  placeholder={schema.organization.hint || `ระบุ${schema.organization.label}`}
                  inputRef={register(isValidators(schema.organization.validators))}
                  onChange={(value) => setOrganization(value)}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={8}>
                <ErrorMessage error={errors[schema.responsibilityRole.name]} />
                <ControlLabel>
                  {requiredFiled(
                    schema.responsibilityRole.validators,
                    schema.responsibilityRole.label
                  )}
                </ControlLabel>
                <Input
                  name={schema.responsibilityRole.name}
                  defaultValue={responsibilityRole}
                  placeholder={
                    schema.responsibilityRole.hint || `ระบุ${schema.responsibilityRole.label}`
                  }
                  inputRef={register(isValidators(schema.responsibilityRole.validators))}
                  onChange={(value) => setResponsibilityRole(value)}
                />
              </Col>
            </Row>

            {isSaveError && (
              <Row style={{ marginTop: 10, marginBottom: 10 }}>
                <Message
                  showIcon
                  type="error"
                  description={`บันทึก${schema.buttonText || schema.header} ไม่สำเร็จ`}
                />
              </Row>
            )}

            <Row style={{ marginTop: 10 }}>
              <IconButton
                appearance="ghost"
                icon={<Icon className="bt-gost-icon-radius" icon={'save'} />}
                onClick={(e) => onSubmit()}
                style={{ marginRight: 5 }}
              >
                {`บันทึก${schema.buttonText || schema.header}`}
              </IconButton>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-cancel"
                icon={
                  <Icon appearance="ghost" icon="close" className="bt-gost-icon-radius-cancel" />
                }
                onClick={(e) => {
                  setIsAdd(false)
                  setIsDeleteFail(false)
                  setIsSaveError(false)
                }}
                style={{ marginRight: 5 }}
              >
                {`ยกเลิก${schema.buttonText || schema.header}`}
              </IconButton>
            </Row>
          </FormGroup>
        </Form>
      </Grid>
    )
  }

  return (
    <div className="component-overview">
      <Panel style={{ marginBottom: '20px' }} bodyFill>
        <Panel header="" eventKey={2} shaded>
          {isAdd ? (
            AddForm()
          ) : (
            <>
              <Row style={{ marginTop: '10px' }}>
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
                  <div>
                    <IconButton
                      appearance="ghost"
                      icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
                      onClick={onAdd}
                      style={{ marginRight: 5 }}
                    >
                      {`เพิ่ม${schema.buttonText || schema.header}`}
                    </IconButton>
                  </div>
                </Col>
              </Row>
            </>
          )}

          {isDeleteFail && (
            <Row style={{ marginTop: 10 }}>
              <Message
                showIcon
                type="error"
                description={`ลบ${schema.buttonText || schema.header} ไม่สำเร็จ`}
              />
            </Row>
          )}

          <Table
            style={{ marginTop: 10 }}
            height={400}
            wordWrap
            autoHeight={schema?.values?.length <= 5}
            data={schema.values || []}
          >
            <Column width={100}>
              <HeaderCell>ข้อที่</HeaderCell>
              <Cell>
                {(_, index) => {
                  return <span>{index + 1}</span>
                }}
              </Cell>
            </Column>
            <Column width={120} flexGrow={1}>
              <HeaderCell>บทบาทหน้าที่</HeaderCell>
              <Cell dataKey="responsibilityRole" />
            </Column>

            <Column width={120} flexGrow={1}>
              <HeaderCell>ชื่อหน่วยงาน</HeaderCell>
              <Cell dataKey="organization" />
            </Column>
            <Column width={120}>
              <HeaderCell></HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <ButtonGroup>
                      <TooltipButton
                        icon="pencil"
                        tooltip={`แก้ไข${schema.buttonText || schema.header}`}
                        disabled={loading}
                        onClick={(e) => handleEdit(rowData)}
                      ></TooltipButton>
                      <TooltipButton
                        icon="trash-o"
                        tooltip={`ลบ${schema.buttonText || schema.header}`}
                        disabled={loading}
                        onClick={(e) => {
                          setDeleteId(rowData.projectCoId)
                          setIsdelete(true)
                        }}
                      ></TooltipButton>
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
          </Table>
        </Panel>
      </Panel>

      <Modal
        show={isdelete}
        onHide={(e) => {
          setIsdelete(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>
        <Modal.Body>{`ยืนยันการลบ ${schema.buttonText || schema.header} `}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={(e) => {
              onDelete(deleteId)
              setIsdelete(false)
            }}
            appearance="primary"
          >
            ลบ
          </Button>
          <Button
            onClick={(e) => {
              setIsdelete(false)
              setDeleteId('')
            }}
            appearance="subtle"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
